// ABOUTME: Root layout component providing app shell structure.
// ABOUTME: Wraps page content with toolbar and tour provider.

import { Outlet, useLocation } from 'react-router-dom';
import { HelpCircle } from 'lucide-react';
import { TourProvider, useTour } from '@/context/TourContext';
import { Toolbar } from './Toolbar';
import { AppTour } from '@/components/tour/AppTour';

function TourHelpButton() {
  const { restartTour, isRunning } = useTour();
  const location = useLocation();

  // Hide help button on onboarding page (user is still getting set up)
  if (location.pathname === '/onboarding') {
    return null;
  }

  // Hide help button on report wizard and report editor (prevents overlap with editor panel footers)
  // Exception: always show during tour so the final step can highlight it
  if (!isRunning && (location.pathname === '/reports/new' || location.pathname.match(/^\/reports\/[^/]+$/))) {
    return null;
  }

  return (
    <button
      onClick={restartTour}
      className="fixed bottom-6 right-6 z-50 group"
      aria-label="Restart tour"
      title="Restart tour"
      data-tour="help-button"
    >
      <div className="relative flex items-center justify-center w-12 h-12 rounded-full bg-obsidian-void/80 border border-obsidian-border/40 backdrop-blur-sm transition-all duration-200 hover:bg-obsidian-void hover:border-obsidian-border hover:scale-110 shadow-lg">
        <HelpCircle className="w-5 h-5 text-obsidian-text-secondary group-hover:text-obsidian-text-primary transition-colors" />
      </div>
    </button>
  );
}

export function RootLayout() {
  return (
    <TourProvider>
      <div className="relative w-full h-screen overflow-hidden bg-surface-50 flex selection:bg-primary-500/30 selection:text-surface-900">
        <div className="relative h-full flex-1 flex flex-col overflow-hidden bg-surface-50 z-10">
          {/* Top Toolbar */}
          <Toolbar />

          {/* Main Content Area */}
          <div className="flex-1 overflow-hidden">
            <Outlet />
          </div>
        </div>

        {/* Onboarding Tour */}
        <AppTour />

        {/* Tour Help Button */}
        <TourHelpButton />
      </div>
    </TourProvider>
  );
}
